import styled from "styled-components";
import {Button, TextField} from "@mui/material";
import { media } from "../../theme/breakpoints";
import theme from "../../theme/theme";

export const StyledCard = styled.div`
    width: 100%;
    max-width: 450px;
    background: #ffffff;
    border: 1px solid #e0e0e0;
    border-radius: 40px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;

    ${media.sm} {
        padding: 32px;
        gap: 20px;
    }

    ${media.md} {
        padding: 40px;
        gap: 24px;
    }
`;

export const Header = styled.h1`
    font-family: 'Manrope', sans-serif;
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
    color: #262626;
    letter-spacing: -0.02em;
    text-align: center;

    ${media.sm} {
        font-size: 22px;
        line-height: 30px;
    }

    ${media.md} {
        font-size: 24px;
        line-height: 33px;
    }
`;

export const Subtext = styled.p`
    font-family: 'Manrope', sans-serif;
    font-size: 13px;
    font-weight: 500;
    line-height: 18px;
    color: #262626;
    letter-spacing: -0.02em;
    text-align: center;
    margin-top: -8px;

    ${media.sm} {
        font-size: 14px;
        line-height: 20px;
    }
`;

export const StyledForm = styled.form`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;

    ${media.sm} {
        gap: 20px;
    }

    ${media.md} {
        gap: 24px;
    }
`;

export const StyledTextField = styled(TextField)`
    && {
        .MuiOutlinedInput-root {
            border-radius: 16px;
            background-color: #ffffff;

            & fieldset {
                border-color: #e0e0e0;
            }

            &:hover fieldset {
                border-color: ${theme.palette.primary.main};
            }

            &.Mui-focused fieldset {
                border-color: ${theme.palette.primary.main};
            }

            &.Mui-error fieldset {
                border-color: #d32f2f;
            }

            &.Mui-error:hover fieldset {
                border-color: #d32f2f;
            }

            &.Mui-error.Mui-focused fieldset {
                border-color: #d32f2f;
            }
        }

        .MuiInputLabel-root {
            font-family: 'Manrope', sans-serif;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #262626;

            &.Mui-focused {
                color: ${theme.palette.primary.main};
            }

            &.Mui-error {
                color: #d32f2f;
            }

            &.Mui-error.Mui-focused {
                color: #d32f2f;
            }
        }

        input {
            font-family: 'Manrope', sans-serif;
            font-size: 14px;
            line-height: 20px;
            color: #262626;
        }

        input:-webkit-autofill {
            box-shadow: 0 0 0 1000px #ffffff inset;
            -webkit-text-fill-color: #262626;
        }
    }
`;

export const StyledButton = styled(Button)`
    && {
        width: 100%;
        height: 60px;
        background-color: ${theme.palette.primary.main};
        border-radius: 16px;
        font-family: 'Manrope', sans-serif;
        font-weight: 700;
        font-size: 18px;
        line-height: 24px;
        letter-spacing: -0.02em;
        color: #fafafa;
        text-transform: none;

        &:hover {
            background-color: #152033;
        }

        &:disabled {
            background-color: rgba(29, 42, 65, 0.12);
            color: rgba(0, 0, 0, 0.26);
        }
    }
`;
